import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import * as s from './hero-customer-logos.module.less';
import Marquee from "react-fast-marquee";

const HeroCustomerLogos = ({ customers, title, titleColor = '#fff' }) => {
  if (!customers || customers.length === 0) {
    return null;
  }

  const displayTitle = title || `Über 40 Unternehmen vertrauen auf unsere Expertise`
  return (
    <div className={s.heroLogosContainer}>
      <p className={s.heroLogosTitle} style={{ color: titleColor }}>
        {displayTitle}
      </p>
      <div className={s.heroLogosGrid}>
      <Marquee
        autoFill={false}
      >
        {customers.filter(({node}) => {
           return node.frontmatter.imagePath?.childImageSharp !== undefined
        }).map(({ node }) => (
            <div key={node.id} className={s.heroLogoItem}>
              <img
                className={s.heroLogoImage}
                src={node.frontmatter.imagePath.publicURL}
                alt={node.frontmatter.name || 'Customer Logo'}
                loading="eager"
                style={{ maxHeight: '35px', maxWidth: '120px', opacity: 0.85 }}
              />
            </div>
        ))}
        </Marquee>
      </div>
    </div>
  );
};

export default HeroCustomerLogos;
